import { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { DataContext } from 'providers/data';

import { Typography, Box, Button, Skeleton } from '@mui/material';

import Timer from 'components/views/Timer';
import ModalCustomerCard from 'components/views/ModalCustomerCard';

import { TypographyTextNav, ContainerCards, Card } from './styles';

import { ReactComponent as IcCar } from 'assets/icons/ic-car-star.svg';
import { ReactComponent as IcInvoices } from 'assets/icons/ic-invoices.svg';
import { ReactComponent as IcCustomerCard } from 'assets/icons/ic-customer-card.svg';

const VehicleData = () => {
    const navigate = useNavigate();
    const [firstTuition, setFirstTuition] = useState('');
    const [showOpenModal, setShowOpenModal] = useState(false);
    const [enabledRequest, setEnabledRequest] = useState(true);
    const [dtCercaIniciada, setDtCercaIniciada] = useState<Date>();
    const { selectedCar, dataFinancialPending, blockClick, dataGetVirtualFencesHistory, customerCars, handlePostGetVirtualFencesHistory } = useContext(DataContext);

    useEffect(() => {
        if (Array.isArray(dataFinancialPending) && dataFinancialPending?.length > 0) {
            const date = dataFinancialPending[0].DT_VENCIMENTO;
            setFirstTuition(`${date.split('/')[0]}/${date.split('/')[1]}`);
        }
    }, [dataFinancialPending]);

    useEffect(() => {
        const dateNow = new Date();
        const dateOld = new Date();
        dateOld.setDate(dateOld.getDate() - 1);

        if ((selectedCar?.TECNOLOGIA === 2) && !dataGetVirtualFencesHistory && enabledRequest) {
            setEnabledRequest(false);
            handlePostGetVirtualFencesHistory({
                body: {
                    PocSag: selectedCar.POCSAG,
                    DtInicio: dateOld.toISOString(),
                    DtFim: dateNow.toISOString(),
                    Ativa: true
                }
            });

            setTimeout(() => {
                setEnabledRequest(true);
            }, 120000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar, dataGetVirtualFencesHistory, enabledRequest]);

    useEffect(() => {
        if (dataGetVirtualFencesHistory) {
            const dateNow = new Date();
            const dateActive = new Date(dataGetVirtualFencesHistory.DtCercaIniciada);
            const timeDifference = dateNow.getTime() - dateActive.getTime();

            if (timeDifference) {
                dateNow.setTime(dateNow.getTime() + timeDifference);
                setDtCercaIniciada(dateNow);
            }
        }
    }, [dataGetVirtualFencesHistory]);

    const handleValidateLevel = () => {
        if (customerCars?.find(({ CD_PESSOA, CD_PESSOA_BENEFICIARIO }) => CD_PESSOA === CD_PESSOA_BENEFICIARIO)) {
            return true;
        } else {
            return false;
        }
    }

    return (
        <Box>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                paddingBottom: {
                    xs: '.75rem',
                    md: '1.5625rem'
                }
            }}>
                <Typography fontSize='.875rem' color='primary.light' fontWeight={700}>
                    Dados do veículo
                </Typography>
                <Box sx={{
                    width: '69%',
                    height: '1.46167px',
                    backgroundColor: '#8D9BB5',
                    display: {
                        xs: 'none',
                        md: 'flex'
                    }
                }} />
            </Box>

            <Box sx={{
                display: 'flex',
                alignItems: 'self-start',
                justifyContent: 'space-between'
            }}>
                <Box sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: {
                        xs: 'column',
                        md: 'row'
                    },
                }}>
                    <Box>
                        <TypographyTextNav paddingBottom='.32rem'>
                            Serviço:
                        </TypographyTextNav>
                        <Typography fontSize='1.25rem' fontWeight={700}>
                            {selectedCar?.PRODUTO}
                            {!selectedCar && blockClick && 'Inativo'}
                        </Typography>
                    </Box>

                    {selectedCar &&
                        <Box sx={{
                            width: {
                                xs: '100%',
                                md: 'fit-content'
                            },
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: '.5rem',
                            paddingTop: {
                                xs: '.5rem',
                                md: '0'
                            }
                        }}>
                            {dtCercaIniciada &&
                                <Box>
                                    <TypographyTextNav paddingBottom='.22rem'>
                                        Cerca ativa há: <Timer offsetTimestamp={dtCercaIniciada} />
                                    </TypographyTextNav>
                                    <TypographyTextNav>
                                        Status: <strong>Ativo</strong>
                                    </TypographyTextNav>
                                </Box>
                            }
                            <Box>
                                <Button sx={{
                                    border: '1px solid #0C1C33',
                                    borderRadius: '100px',
                                    height: '1.875rem',
                                    width: {
                                        xs: '6.625rem',
                                        md: '7.5rem'
                                    },
                                    fontWeight: 700,
                                    fontSize: '.75rem'
                                }}
                                    onClick={() => navigate('/meus-veiculos')}
                                >
                                    DETALHES
                                </Button>
                            </Box>
                        </Box>
                    }
                </Box>
            </Box>

            <ContainerCards>
                <Card sx={{
                    border: '1.86324px solid rgba(151, 201, 61, 0.5)',
                    boxShadow: '0px 2.79487px 5.58973px #97C93D',
                }}>
                    <Box sx={{
                        width: '100%',
                        height: '60%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        {Array.isArray(dataFinancialPending) && dataFinancialPending?.length > 0 ?
                            firstTuition ?
                                <Typography fontWeight={700} textAlign='center' paddingTop='1rem'
                                    sx={{
                                        fontSize: {
                                            xs: '1.72rem',
                                            md: '2.5rem'
                                        }
                                    }}
                                >
                                    {firstTuition}
                                </Typography>
                                :
                                <Typography fontSize='.9375rem' fontWeight={600} textAlign='center' paddingTop='1rem' lineHeight='1.1'>
                                    Não há faturas <br />
                                    em aberto
                                </Typography>
                            :
                            <Skeleton variant="rounded" width='80%' height={60} />
                        }
                    </Box>
                    <Box sx={{
                        width: '101%',
                        height: '40%',
                        display: 'flex',
                        margin: '0 -4px -4px',
                        borderRadius: '5px',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'secondary.main',
                        border: '1.86324px solid rgba(151, 201, 61, 0.5)',
                    }}>
                        <Typography fontWeight={700} textAlign='center'
                            sx={{
                                fontSize: {
                                    xs: '.78rem',
                                    md: '.9375rem'
                                },
                                lineHeight: {
                                    xs: '12.26px',
                                    md: '18px'
                                }
                            }}
                        >
                            Vencimento da
                            próxima fatura
                        </Typography>
                    </Box>
                </Card>

                <Card sx={{
                    border: '1.86324px solid #0C1C33',
                    cursor: blockClick ? 'not-allowed' : 'pointer',
                    opacity: blockClick ? '.2' : '1'
                }}
                    onClick={() => !blockClick && setShowOpenModal(true)}
                >
                    <IcCustomerCard />
                    <Typography fontSize='.9375rem' fontWeight={600} textAlign='center' paddingTop='1rem'>
                        Cartão do <br /> cliente
                    </Typography>
                </Card>

                <Card sx={{
                    border: '1.86324px solid #0C1C33',
                    cursor: 'pointer'
                }}
                    onClick={() => navigate('/faturas')}
                >
                    <IcInvoices />
                    <Typography fontSize='.9375rem' fontWeight={600} textAlign='center' paddingTop='.5rem'>
                        Faturas
                    </Typography>
                </Card>

                <Card sx={{
                    display: {
                        xs: 'none',
                        md: 'flex'
                    },
                    backgroundColor: 'primary.main',
                    cursor: handleValidateLevel() && !blockClick ? 'pointer' : 'not-allowed',
                    opacity: handleValidateLevel() && !blockClick ? '1' : '.2'
                }}
                    onClick={() => handleValidateLevel() && !blockClick && navigate('/central-de-trocas')}
                >
                    <Box sx={{
                        width: '100%',
                        height: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <IcCar />
                    </Box>
                    <Box sx={{
                        width: '100%',
                        height: '50%',
                        display: 'flex',
                        borderRadius: '12px',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'secondary.main'
                    }}>
                        <Typography fontSize='1.125rem' fontWeight={700} textAlign='center' color='white' lineHeight='22px'>
                            Conheça outros <br />
                            <strong style={{
                                fontSize: '1.125rem',
                                textAlign: 'center',
                                color: '#0C1C33'
                            }}>
                                PLANOS
                            </strong>
                        </Typography>
                    </Box>
                </Card>
            </ContainerCards>
            <ModalCustomerCard open={showOpenModal} handleClick={(e) => setShowOpenModal(e)} />
        </Box >
    );
}

export default VehicleData;